import styled from 'styled-components'

import { Badges } from '../Badges'

export const StyledBadges = styled(Badges)<{ shouldRenderInline?: boolean }>`
  margin-top: 0;
  ${({ shouldRenderInline }) => shouldRenderInline && 'width: auto'};

  > div {
    margin-top: 0;
  }
`
